import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Upload, FileSpreadsheet } from 'lucide-react';

const TDSReturnUpload = ({
  fileInputRef,
  uploadedFile,
  uploading,
  onFileSelect,
  onUpload
}) => {
  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      onFileSelect(file);
    }
  };

  return (
    <Card>
      <CardContent className="pt-6">
        <div className="space-y-4">
          <div className="border-2 border-dashed border-slate-200 rounded-lg p-8 text-center hover:border-emerald-300 transition-colors">
            <FileSpreadsheet className="w-12 h-12 mx-auto text-slate-400 mb-4" />
            <h3 className="font-medium mb-2">Upload TDS Return File</h3>
            <p className="text-sm text-slate-500 mb-4">
              Supports Excel (.xlsx, .xls) or CSV files exported from TRACES or other TDS filing portals
            </p>
            
            <div className="flex flex-col items-center gap-3">
              <Label htmlFor="tds-return-file" className="cursor-pointer">
                <Input
                  id="tds-return-file"
                  type="file"
                  accept=".xlsx,.xls,.csv"
                  onChange={handleFileChange}
                  ref={fileInputRef}
                  className="hidden"
                  data-testid="tds-return-file-input"
                />
                <Button type="button" variant="outline" asChild>
                  <span>
                    <Upload className="w-4 h-4 mr-2" />
                    Select File
                  </span>
                </Button>
              </Label>
              
              {uploadedFile && (
                <div className="text-sm text-emerald-600 flex items-center gap-2">
                  <FileSpreadsheet className="w-4 h-4" />
                  {uploadedFile.name}
                </div>
              )}
            </div>
          </div>

          {uploadedFile && (
            <Button 
              className="w-full" 
              onClick={onUpload}
              disabled={uploading}
              data-testid="upload-return-btn"
            >
              {uploading ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                  Processing...
                </>
              ) : (
                <>
                  <Upload className="w-4 h-4 mr-2" />
                  Upload & Process
                </>
              )}
            </Button>
          )}

          <div className="bg-blue-50 rounded-lg p-4">
            <h4 className="font-medium text-blue-800 text-sm mb-2">Expected File Format</h4>
            <ul className="text-xs text-blue-700 space-y-1 list-disc list-inside">
              <li>PAN column (required)</li>
              <li>Party/Deductee Name</li>
              <li>TDS Amount / Tax Deducted</li>
              <li>Total Payment / Gross Amount</li>
              <li>Date of Payment/Credit (optional)</li>
            </ul>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default TDSReturnUpload;
